import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { FibberglassRequestDTO } from '../models/fibberglass-request-dto.model';
import { UserResponseDto } from '../models/adminResponseDto';

@Injectable({
  providedIn: 'root'
})
export class FibberglassRequestService {

  constructor(private http: HttpServices) { }

  public getFibberglassRequest (RequestId: string) {
    return this.http.get('Fibberglass/GetFibberglass/' + RequestId);
  }

  public addFibberglassRequest (fibberglassRequest: FibberglassRequestDTO) {
    return this.http.post('Fibberglass/AddFibberglass/', fibberglassRequest);
  }

  public getServiceImage (serviceId: number) {
    return this.http.get('Fibberglass/GetServiceImage/' + serviceId);
  }

  public getBoatTypeSettings (boatTypeId: number) {
    return this.http.get('Fibberglass/GetBoatTypeSettings/' + boatTypeId);
  }

  public ConfirmFibberglassContract (userResponse: UserResponseDto) {
    return this.http.post('Fibberglass/ConfirmFibberglassContract/', userResponse);
  }

  public ConfirmFibberglassPayment (userResponse: UserResponseDto) {
    return this.http.post('Fibberglass/ConfirmFibberglassPayment/', userResponse);
  }
  
}
